<script lang="ts">
import type { VariantProps } from 'class-variance-authority'
import type { HTMLAttributes } from 'vue'
import { cva } from 'class-variance-authority'

export const spinnerVariants = cva('animate-spin shrink-0', {
  variants: {
    size: {
      xs: 'size-4',
      sm: 'size-6',
      md: 'size-9',
      lg: 'size-18',
    },
  },
  defaultVariants: {
    size: 'xs',
  },
})

export type SpinnerVariants = VariantProps<typeof spinnerVariants>

export interface SpinnerProps {
  size?: SpinnerVariants['size']
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<SpinnerProps>()
</script>

<template>
  <svg
    :class="cn(spinnerVariants({ size: props.size }), props.class)"
    viewBox="0 0 24 24"
    fill="none"
    role="status"
    aria-label="Loading"
  >
    <path
      fill="currentColor"
      fill-opacity="0.1"
      d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z"
    />
    <path
      fill="currentColor"
      d="M22.1554 9.33226C22.9567 9.12178 23.4443 8.29667 23.1356 7.52792C22.7367 6.53486 22.206 5.59749 21.556 4.74172C20.6028 3.48681 19.4118 2.43192 18.051 1.6373C16.6901 0.842669 15.1861 0.323864 13.6247 0.1105C12.56 -0.0350017 11.4828 -0.0365167 10.422 0.104212C9.60072 0.213153 9.12178 1.04331 9.33226 1.84455C9.54273 2.64579 10.3641 3.11124 11.1891 3.0366C11.8636 2.97559 12.5444 2.99075 13.2186 3.08287C14.3896 3.2429 15.5176 3.632 16.5382 4.22797C17.5589 4.82394 18.4521 5.6151 19.167 6.55629C19.5786 7.09813 19.9264 7.68359 20.2047 8.30097C20.5452 9.05619 21.3542 9.54274 22.1554 9.33226Z"
    />
  </svg>
</template>
